import { render, staticRenderFns } from "./NavScrollTo.vue?vue&type=template&id=bf2dde72&"
import script from "./NavScrollTo.vue?vue&type=script&lang=js&"
export * from "./NavScrollTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports